/**
 * Notification System
 * Sistem i thjeshtë për notifications (mund të zëvendësohet me react-toastify, etc.)
 */

let notificationListeners = [];

export const notificationService = {
  // Listeners
  subscribe: (callback) => {
    notificationListeners.push(callback);
    return () => {
      notificationListeners = notificationListeners.filter(cb => cb !== callback);
    };
  },

  // Notifikim suksesi
  success: (message, duration = 3000) => {
    notificationListeners.forEach(callback => {
      callback({ type: 'success', message, duration });
    });
  },

  // Notifikim error
  error: (message, duration = 5000) => {
    notificationListeners.forEach(callback => {
      callback({ type: 'error', message, duration });
    });
  },

  // Notifikim warning
  warning: (message, duration = 4000) => {
    notificationListeners.forEach(callback => {
      callback({ type: 'warning', message, duration });
    });
  },

  // Notifikim info
  info: (message, duration = 3000) => {
    notificationListeners.forEach(callback => {
      callback({ type: 'info', message, duration });
    });
  },
};





